import { BATHROOM_CDN_PATH } from '../../old-bathroom-constants';
import { resultImageTextStyle } from './result-section-styles';

export const RESULT_LIST = [
  {
    src: `${BATHROOM_CDN_PATH}/result/1.jpg/1-01.jpg`,
    alt: 'result-section.result-help-title',
    text: 'result-section.result-help-title',
  },
  {
    src: `${BATHROOM_CDN_PATH}/result/2.jpg/2.jpg`,
    alt: 'result-section.result-3d-title',
    text: 'result-section.result-3d-title',
  },
  {
    src: `${BATHROOM_CDN_PATH}/result/3.jpg/3.jpg`,
    alt: 'result-section.result-plan-alt',
    text: 'result-section.result-plan-title',
    className: resultImageTextStyle,
  },
  {
    src: `${BATHROOM_CDN_PATH}/result/4.jpg/4.jpg`,
    alt: 'result-section.result-total-alt',
    text: 'result-section.result-total-title',
  },
];
